/**
 * HALFSONE — product gallery, variants and sticky purchase bar.
 */

class NevorelProduct {
  constructor() {
    this.container = document.querySelector('[data-section-type="main-product"]');
    if (!this.container) return;

    this.variantSelectors = this.container.querySelectorAll('[data-variant-radio]');
    this.variantIdInput = this.container.querySelector('[data-selected-variant-id]');
    this.selectedLabel = this.container.querySelector('[data-selected-option-label]');
    this.priceElement = this.container.querySelector('[data-product-price]');
    this.comparePriceElement = this.container.querySelector('[data-product-compare-price]');
    this.buttonPrice = this.container.querySelector('[data-button-price]');
    this.addToCartBtn = this.container.querySelector('[data-add-to-cart-btn]');
    this.formMessage = this.container.querySelector('[data-product-form-message]');
    this.galleryMainImg = this.container.querySelector('[data-main-gallery-image]');
    this.thumbBtns = this.container.querySelectorAll('[data-gallery-thumb]');
    this.stickyBar = document.getElementById('StickyAddToCart');
    this.stickyButton = this.stickyBar?.querySelector('[data-sticky-add-to-cart]');
    this.stickyPrice = this.stickyBar?.querySelector('[data-sticky-price]');
    this.stickyVariant = this.stickyBar?.querySelector('[data-sticky-variant]');
    this.stickyImage = this.stickyBar?.querySelector('[data-sticky-image]');

    this.bindVariants();
    this.bindGallery();
    this.bindStickyBar();
  }

  bindVariants() {
    this.variantSelectors.forEach((radio) => {
      radio.addEventListener('change', () => this.selectVariant(radio));
    });

    const checked = this.container.querySelector('[data-variant-radio]:checked');
    if (checked) this.selectVariant(checked, false);
  }

  selectVariant(radio, updateUrl = true) {
    const variantId = radio.dataset.variantId;
    const title = radio.dataset.variantTitle || 'Seçilen seçenek';
    const price = radio.dataset.price || '';
    const comparePrice = radio.dataset.comparePrice || '';
    const available = radio.dataset.available === 'true';
    const imageSrc = radio.dataset.imageSrc || '';

    if (this.variantIdInput) this.variantIdInput.value = variantId;
    if (this.selectedLabel) this.selectedLabel.textContent = title;

    this.container.querySelectorAll('.variant-chip').forEach((chip) => {
      chip.classList.toggle('selected', chip.contains(radio));
    });

    if (this.priceElement && price) this.priceElement.textContent = price;
    if (this.buttonPrice && price) this.buttonPrice.textContent = price;
    if (this.stickyPrice && price) this.stickyPrice.textContent = price;
    if (this.stickyVariant) this.stickyVariant.textContent = title;

    if (this.comparePriceElement) {
      this.comparePriceElement.textContent = comparePrice;
      this.comparePriceElement.hidden = !comparePrice;
    }

    this.setPurchaseState(available);

    if (imageSrc) {
      if (this.galleryMainImg) {
        this.galleryMainImg.src = imageSrc;
        this.galleryMainImg.removeAttribute('srcset');
      }
      if (this.stickyImage) this.stickyImage.src = imageSrc;
    }

    if (updateUrl && variantId && window.history?.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.toString());
    }
  }

  setPurchaseState(available) {
    const label = available ? 'Sepete ekle' : 'Tükendi';

    if (this.addToCartBtn) {
      this.addToCartBtn.disabled = !available;
      const text = this.addToCartBtn.querySelector('.btn-text');
      if (text) text.textContent = label;
    }
    if (this.stickyButton) {
      this.stickyButton.disabled = !available;
      const text = this.stickyButton.querySelector('[data-sticky-label]');
      if (text) text.textContent = label;
    }
    if (this.formMessage) {
      this.formMessage.textContent = available
        ? ''
        : 'Bu seçenek şu anda tükendi.';
    }
  }

  bindGallery() {
    this.thumbBtns.forEach((button) => {
      button.addEventListener('click', () => {
        const fullSrc = button.dataset.fullSrc;
        if (fullSrc && this.galleryMainImg) {
          this.galleryMainImg.src = fullSrc;
          this.galleryMainImg.removeAttribute('srcset');
        }
        this.thumbBtns.forEach((thumb) => thumb.classList.remove('active'));
        button.classList.add('active');
      });
    });
  }

  bindStickyBar() {
    if (this.stickyButton && this.addToCartBtn) {
      this.stickyButton.addEventListener('click', () => {
        this.addToCartBtn.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (!this.addToCartBtn.disabled) this.addToCartBtn.click();
      });
    }

    if (!this.addToCartBtn || !this.stickyBar || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const shouldShow = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        this.stickyBar.classList.toggle('visible', shouldShow);
        this.stickyBar.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      });
    });

    observer.observe(this.addToCartBtn);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.NevorelProductPage = new NevorelProduct();
});
